import { useMemo } from 'react';

import { useAuth } from '@client/context/auth/AuthContext';

import { getPathDocRef } from '@app/frontend/lib/firebase';
import useFirestoreDocumentFetch from '@app/frontend/lib/firebase/hooks/useFirestoreDocumentFetch';

import { type ConfigurationInfo } from '@app/lib/firebase/types';

type FeatureFlags = ConfigurationInfo['featureFlags'];
type GlobalFeatureFlags = {
  maintenanceModeEnabled: boolean;
};

export const useFeatureFlags = (userId?: string) => {
  const { logOut } = useAuth();

  if (!userId) {
    logOut();
  }

  const configurationInfoDocRef = useMemo(
    () => getPathDocRef(`users/${userId}/userInfo/configurationInfo`),
    [userId],
  );
  const globalConfigurationDocRef = useMemo(() => getPathDocRef(`config/featureFlags`), []);

  const { data: configurationInfo, loading: configurationInfoLoading } = useFirestoreDocumentFetch(
    configurationInfoDocRef,
    { useCache: false },
  );

  const { data: globalConfiguration, loading: globalConfigurationLoading } =
    useFirestoreDocumentFetch(globalConfigurationDocRef, { useCache: false });

  const featureFlags: FeatureFlags & GlobalFeatureFlags = {
    ...configurationInfo?.featureFlags,
    maintenanceModeEnabled: globalConfiguration?.data?.maintenanceModeEnabled,
  };

  const isLoading = configurationInfoLoading || globalConfigurationLoading;

  return { ...featureFlags, isLoading };
};
